module.exports = __webpack_public_path__ + "img/gas_station.ef4ded94.svg";